import '../../../scss/styles.scss';

import React from 'react';
import {Provider} from "mobx-react";
import {BootstrapModuleComposer} from "./bootstrap-module.compser";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {UseErrorBoundaries} from "../../components/composers/composer-plugins/use-error-boundaries";
import {AsyncComponent} from "../../components/router/async-component";
import {LoadingIndicator} from "../../components/loading/loading-indicator";
import styles from '../styles/bootstrap.module.scss';
import classnames from "classnames";
import type {BootstrapModuleController} from "../bootstrap-module.controller";

export class BootstrapProps extends BaseProps {
  providerProps: BaseProps;
  appModuleProps: BaseProps;
  controller: BootstrapModuleController;
}

const AppModule = AsyncComponent(() => import('../../app/components/app.module' /* webpackChunkName: "app" */));

const BootstrapModule = UseErrorBoundaries(BootstrapModuleComposer((props: BootstrapProps) => {
  const isWidget = props.controller.config.isWidget;

  return (
    <Provider {...props.providerProps}>
      <React.Suspense fallback={<div/>}>
        <>
          {isWidget && <div id={`widgets-loader_${props.controller.settings.widgetId}`} className={classnames(styles.loader_container)}>
            <LoadingIndicator/>
          </div>}
          <AppModule {...props.appModuleProps}/>
        </>

      </React.Suspense>
    </Provider>
  );
}));

export default BootstrapModule;
